// onboarding-api.js — thin client for the backend onboarding endpoints.
//
// The Phase-1 prototype keeps its mock dataset in localStorage; only the
// apply→approve→KYC→login flow round-trips to the FastAPI backend (so that
// the admin in one browser session can see + approve an application
// submitted by a different user in a different session, and a real email
// goes out via Resend).

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function jsonOrThrow(res) {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const msg  = body.detail || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return res.json();
}

// ─── Applications ─────────────────────────────────────────────────────────
export async function listLiveApplications(status) {
  const url = status ? `${BASE}/applications?status=${encodeURIComponent(status)}` : `${BASE}/applications`;
  const res = await fetch(url);
  return jsonOrThrow(res);
}

export async function getLiveApplication(appId) {
  const res = await fetch(`${BASE}/applications/${appId}`);
  return jsonOrThrow(res);
}

export async function approveLiveApplication(appId, reviewer = {}) {
  const res = await fetch(`${BASE}/applications/${appId}/approve`, {
    method:  "PATCH",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify({
      reviewerId:    reviewer.reviewerId    || "adm_001",
      reviewerNotes: reviewer.reviewerNotes || null,
    }),
  });
  return jsonOrThrow(res);
}

export async function rejectLiveApplication(appId, rejectReason, reviewerId = "adm_001") {
  const res = await fetch(`${BASE}/applications/${appId}/reject`, {
    method:  "PATCH",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify({ reviewerId, rejectReason }),
  });
  return jsonOrThrow(res);
}

// ─── KYC ──────────────────────────────────────────────────────────────────
export async function getKycContext(token) {
  const res = await fetch(`${BASE}/kyc/${token}`);
  return jsonOrThrow(res);
}

export async function completeKyc(token, payload) {
  const res = await fetch(`${BASE}/kyc/${token}/complete`, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

// ─── Sign-in (provisional, temp-password) ─────────────────────────────────
export async function onboardingLogin(email, password) {
  const res = await fetch(`${BASE}/onboarding/login`, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify({ email, password }),
  });
  return jsonOrThrow(res);
}

export async function onboardingPasswordChange(email, currentPassword, newPassword) {
  const res = await fetch(`${BASE}/onboarding/password-change`, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify({ email, currentPassword, newPassword }),
  });
  return jsonOrThrow(res);
}
